<tableau-viz *ngIf="shouldDisplay" id='tableau-viz' src='https://tableau.corp.global/t/cs/views/WS_POC/ProjectAnalysis' width='1600' height='888' style="display:block;" toolbar='bottom' ></tableau-viz>
<div class="container">
  <p>This page is currently disabled</p>
</div>
